import getAMBClient from './getAMBClient';
import {replaceChannelParameters} from './utils';

export const AMB_MESSAGE_PUBLISHED = 'AMB_MESSAGE_PUBLISHED';

export function ambPublishEffect(ambClient, channelId, options = {}, coeffects) {
	const {
		messagePublishedActionType = AMB_MESSAGE_PUBLISHED,
		encodeURIComponentForChannelId = true
	} = options;
	const {action, dispatch} = coeffects;
	const resolvedChannel = replaceChannelParameters(
		channelId,
		action.payload,
		encodeURIComponentForChannelId
	);

	// Should be able to publish messages even if not subscribed to channel
	const channelListener = ambClient.getChannel(resolvedChannel);

	if (channelListener) {
		const {payload: message = {}} = action;
		channelListener.publish(message);
		dispatch(messagePublishedActionType, message, {...action.meta, channelId: resolvedChannel});
	}
}

/**
 * Effect to publish messages over an amb channel.
 *
 * @function createAmbPublishEffect
 * @example
 * import {createAmbPublishEffect} from '@servicenow/ui-effect-amb';
 *
 * const chatMessagePublishedEffect = createAmbPublishEffect('/chat/messages', {
 *     messagePublishedActionType: 'CHAT_MESSAGE_PUBLISH_COMPLETED'
 * });
 *
 * const chatComponent = createCustomElement('sn-chat', {
 *      renderer: {
 *          view: (state, dispatch) => {
 *              function sendMessage() {
 *                  dispatch('CHAT_MESSAGE_PUBLISHED', {
 *                     text: 'Hello World'
 *                  });
 *              }
 *
 *              return <button on-click="sendMessage">Send Message</button>
 *          }
 *      },
 *      actionHandlers: {
 *		    'CHAT_MESSAGE_PUBLISHED': chatMessagePublishedEffect
 *		}
 * });
 *
 * @param {String} channelId - AMB Channel ID
 * @param {Object} options
 * @param {Object} options.messagePublishedActionType = Action dispatched when an amb message publish completes
 * @param {Boolean} options.encodeURIComponentForChannelId - Encode channel id URL (default: true)
 * @return {Object} AMB Publish Effect Descriptor
 */
export default function createAmbPublishEffect(channelId, options) {
	return {
		effect: ambPublishEffect,
		args: [getAMBClient(), channelId, options]
	};
}
